import apiHandler from "../core/apiHandler";

const usersApi = apiHandler('users');
export default usersApi;
